




















import ApiConfiguration from '@/classes/ApiConfiguration';
import { DocumentPrintResponseModel } from '@/services/GeneratedApi';
import { Base64Utils } from '@/utils';
import Vue from 'vue';
import LoadingSpinner from './LoadingSpinner.vue';
import MStoreSpinnerButton from './MStoreSpinnerButton.vue';

export default Vue.extend({
  name: 'MStorePrintDocument',
  props: {
    cabinetId: {
      type: String
    },
    documentId: {
      type: Number
    },
    size: {
      type: String,
      required: false
    },
    isDropdownButton: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      base64BlobUrls: {} as { [key: number]: string },
      isLoading: false
    };
  },
  methods: {
    async print(this: any) {
      try {
        this.isLoading = true;
        if (!this.base64BlobUrls[this.documentId]) {
          const pdfDocument = (await ApiConfiguration.api().documentPrint.documentPrintPdfDetail(this.cabinetId, this.documentId)) as DocumentPrintResponseModel;
          this.base64BlobUrls[this.documentId] = Base64Utils.previewBase64(pdfDocument.base64Data!, null);
        }
        requestAnimationFrame(() => this.$refs.printObject.contentWindow.print());
      } finally {
        this.isLoading = false;
      }
    }
  },
  components: { MStoreSpinnerButton, LoadingSpinner }
});
